import ReactInputMask from 'react-input-mask';

export const companiesLegalEntityAddEditSections = [
  {
    title: 'Данные компании',
    fields: [
      { id: 'name', inputName: 'name', label: 'Название' },
      { id: 'inn', inputName: 'inn', label: 'ИНН' },
      { id: 'email', inputName: 'email', label: 'Email' },
      { id: 'phoneNumber', inputName: 'phoneNumber', label: 'Телефон', as: ReactInputMask, mask: '+7 (***) ***-**-**' },
      { id: 'additionalPhone', inputName: 'additionalPhone', label: 'Доп.номер телефона', as: ReactInputMask, mask: '+7 (***) ***-**-**' },
    ],
    checkbox: { id: 'onlineDocuments', inputName: 'onlineDocuments', label: 'Отправить документы онлайн' },
  },
  {
    title: 'Юридический адрес',
    fields: [
      { id: 'legalAddress.country', inputName: 'legalAddress.country', label: 'Страна юр. адреса' },
      { id: 'legalAddress.region', inputName: 'legalAddress.region', label: 'Регион юр. адреса' },
      { id: 'legalAddress.city', inputName: 'legalAddress.city', label: 'Город юр. адреса' },
      { id: 'legalAddress.street', inputName: 'legalAddress.street', label: 'Улица юр. адреса' },
      { id: 'legalAddress.house', inputName: 'legalAddress.house', label: 'Дом юр. адреса' },
      { id: 'legalAddress.apartment', inputName: 'legalAddress.apartment', label: 'Офис юр. адреса' },
      { id: 'legalAddress.postcode', inputName: 'legalAddress.postcode', label: 'Почтовый индекс юр. адреса' },
    ],
  },
  {
    title: 'Адрес доставки',
    fields: [
      { id: 'deliveryAddress.country', inputName: 'deliveryAddress.country', label: 'Страна доставки' },
      { id: 'deliveryAddress.region', inputName: 'deliveryAddress.region', label: 'Регион доставки' },
      { id: 'deliveryAddress.city', inputName: 'deliveryAddress.city', label: 'Город доставки' },
      { id: 'deliveryAddress.street', inputName: 'deliveryAddress.street', label: 'Улица доставки' },
      { id: 'deliveryAddress.house', inputName: 'deliveryAddress.house', label: 'Дом доставки' },
      { id: 'deliveryAddress.apartment', inputName: 'deliveryAddress.apartment', label: 'Офис доставки' },
      { id: 'deliveryAddress.postcode', inputName: 'deliveryAddress.postcode', label: 'Почтовый индекс доставки' },
    ],
  },
];

export const orderConfirmFormSections = {
  title: 'Адрес доставки',
  fields: [
    { id: 'country', inputName: 'country', label: 'Страна доставки' },
    { id: 'region', inputName: 'region', label: 'Регион доставки' },
    { id: 'city', inputName: 'city', label: 'Город доставки' },
    { id: 'street', inputName: 'street', label: 'Улица доставки' },
    { id: 'house', inputName: 'house', label: 'Дом доставки' },
    { id: 'apartment', inputName: 'apartment', label: 'Офис доставки' },
    { id: 'postcode', inputName: 'postcode', label: 'Почтовый индекс доставки' },
  ],
};
